import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface HeaderProps {
  isLoading: boolean;
  onRetryLoad?: () => void;
  onLogout: () => void;
  showRetryButton: boolean;
}

const Header: React.FC<HeaderProps> = ({ isLoading, onRetryLoad, onLogout, showRetryButton }) => {
  const location = useLocation();
  
  return (
    <header className="bg-white shadow fixed w-full z-10">
      <div className="max-w-full mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900 mr-8">Marketing Research</h1>
            <nav className="flex space-x-4">
              <Link
                to="/"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  location.pathname === '/' 
                    ? 'bg-indigo-600 text-white' 
                    : 'text-gray-700 hover:bg-gray-200'
                }`}
              >
                Marketing
              </Link>
              <Link
                to="/sales"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  location.pathname === '/sales' 
                    ? 'bg-indigo-600 text-white' 
                    : 'text-gray-700 hover:bg-gray-200'
                }`}
              >
                Sales
              </Link>
            </nav>
          </div>
          
          <div className="flex items-center space-x-4">
            {isLoading && <span className="text-blue-500">Yükleniyor...</span>}
            {showRetryButton && onRetryLoad && (
              <button
                onClick={onRetryLoad}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded text-xs"
              >
                Veri Yüklemesini Yeniden Dene
              </button>
            )}
            <button 
              onClick={onLogout}
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-1 px-2 rounded text-xs"
            >
              Çıkış Yap
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 